var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 700,
    viewBox: "0 0 1440 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -116H1440V321H0V-116ZM0 573L21.6 555C43.2 537 87.6 501 130.8 519C174 537 218.4 609 261.6 633C306 657 349.2 633 392.4 603C436.8 573 480 537 523.2 501C567.6 465 610.8 429 654 405C698.4 381 741.6 369 786 405C829.2 441 872.4 525 916.8 537C960 549 1003.2 489 1047.6 489C1090.8 489 1134 549 1178.4 573C1221.6 597 1266 585 1309.2 537C1352.4 489 1396.8 405 1418.4 363L1440 321H1418.4C1396.8 321 1352.4 321 1309.2 321C1266 321 1221.6 321 1178.4 321C1134 321 1090.8 321 1047.6 321C1003.2 321 960 321 916.8 321C872.4 321 829.2 321 786 321C741.6 321 698.4 321 654 321C610.8 321 567.6 321 523.2 321C480 321 436.8 321 392.4 321C349.2 321 306 321 261.6 321C218.4 321 174 321 130.8 321C87.6 321 43.2 321 21.6 321H0V573Z",
    fill: "#B3E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -116H1440V321H0V-116ZM0 573L21.6 555C43.2 537 87.6 501 130.8 519C174 537 218.4 609 261.6 633C306 657 349.2 633 392.4 603C436.8 573 480 537 523.2 501C567.6 465 610.8 429 654 405C698.4 381 741.6 369 786 405C829.2 441 872.4 525 916.8 537C960 549 1003.2 489 1047.6 489C1090.8 489 1134 549 1178.4 573C1221.6 597 1266 585 1309.2 537C1352.4 489 1396.8 405 1418.4 363L1440 321H1418.4C1396.8 321 1352.4 321 1309.2 321C1266 321 1221.6 321 1178.4 321C1134 321 1090.8 321 1047.6 321C1003.2 321 960 321 916.8 321C872.4 321 829.2 321 786 321C741.6 321 698.4 321 654 321C610.8 321 567.6 321 523.2 321C480 321 436.8 321 392.4 321C349.2 321 306 321 261.6 321C218.4 321 174 321 130.8 321C87.6 321 43.2 321 21.6 321H0V573Z",
    fill: "#B3E3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 700,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.ea9f4a6583870aef12d76a79994a1e0f.svg";
export { ForwardRef as ReactComponent };